export default __webpack_public_path__ + "static/media/logo.f6d613cb.png";